import { Banner, Text, InlineStack, Spinner, Box } from '@shopify/polaris';

const RequiresRefreshBanner = () => {
  return(
    <Box padding="400">
      <Banner tone="warning" title="Refresh Page" onDismiss={() => {}}>
        <InlineStack>
          <Text>The app's Shopify security token has expired. Refresh this page to reload the app with a new token.</Text>
        </InlineStack>
      </Banner>
    </Box>
  )
}

export default RequiresRefreshBanner;
